(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('client-logo', {
            parent: 'settings',
            url: '/logo',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.settings.client-logo.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/client-logo/client-logo.html',
                    controller: 'ClientLogoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client-logo');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
